export class CustomParamsApproacherModel {
  ApproacherOrganizationId: number;
  ApproacherId: number;
}
